import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey } from '../reducers/user-claims.reducer';

export const selectUserState = createFeatureSelector<any>(featureKey);

// Actual Selectors
export const getCurrUser = createSelector(selectUserState, (state: any) => state);
